/**
 * Content Messages
 *
 * This contains all the text for the Content component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.knowledge.container';

export default defineMessages({
  failedKnowledgeMapFetch: {
    id: `${scope}.failedKnowledgeMapFetch`,
    defaultMessage: 'There was an error loading the Competency Document',
  },
});
